import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import TextBox from "../common/TextBox";
import ComboBox from "../common/ComboBox";
import FileUploader from "../common/FileUploader";
import Button from "../common/Button";

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as FileUploaderPlaceholderSvg } from "../../assets/icons/fileuploader-placeholder.svg";
import { ReactComponent as TrashSvg } from "../../assets/icons/trash.svg";

import NewProjectContext from "../../contexts/NewProjectContext";
import { toast } from "react-toastify";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";

const UploadWorks = (props) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  const { goForward, goBackward, details, setDetails } =
    useContext(NewProjectContext);
  const [dragActive, setDragActive] = useState(false);
  const [files, setFiles] = useState(details?.files || []);

  const handleFiles = (newFiles) => {
    if (newFiles.length === 0) return;

    setFiles((curr) => {
      // * Filter out duplicate files
      const existingFilenames = curr.map((c) => c.name);

      const _files = [...newFiles].filter(
        (file) => !existingFilenames.includes(file.name)
      );

      return [...curr, ..._files];
    });
  };

  const handleRemoveImage = (file) => {
    setFiles((curr) => [...curr.filter((f) => f.name !== file.name)]);
  };

  const handleDragDropEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if ((e.type === "dragenter" || e.type === "dragover") && !dragActive) {
      setDragActive(true);
    }

    if ((e.type === "dragleave" || e.type === "drop") && dragActive) {
      setDragActive(false);
    }

    if (e.type === "drop") {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleReturn = () => {
    setDetails((curr) => ({ ...curr, files }));
    goBackward();
  };

  const handleContinue = () => {
    const totalSize = files.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.size;
    }, 0);

    if (totalSize / 1000000000 >= 5) {
      toast.warn("Over limit file size");
      return;
    }

    setDetails((curr) => ({ ...curr, files }));
    goForward();
  };

  return (
    <div className="new-project-image-upload">
      <h1 className="new-project__heading1">
        {Translation("Upload your work")}
      </h1>
      <div
        className={`new-project-image-upload-fileuploader ${
          dragActive ? "new-project-image-upload-fileuploader--highlight" : ""
        }`}
        onDragEnter={handleDragDropEvents}
        onDragOver={handleDragDropEvents}
        onDragLeave={handleDragDropEvents}
        onDrop={handleDragDropEvents}
      >
        <FileUploaderPlaceholderSvg />
        <p className="new-project-image-upload-fileuploader__info">
          {Translation("Drop your files here or")}{" "}
          <label
            className="new-project-image-upload-fileuploader__input-trigger"
            htmlFor="new-project-image-upload-fileuploader__input"
          >
            {Translation("browse")}
          </label>
          <br />
          {Translation("Supports: Blender, C4D, Maya, CAD, 3D Max")}
          <br />
          <span className="new-project-image-upload-fileuploader__limit">
            {Translation("Limit")} 5 GB
          </span>
        </p>
        <input
          id="new-project-image-upload-fileuploader__input"
          type="file"
          multiple
          accept="image/*"
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
      <div className="new-project-image-upload-gallery-scroller">
        <div className="new-project-image-upload-gallery">
          {[...files].map((file) => {
            const _src = URL.createObjectURL(file);
            return (
              <div
                className="new-project-image-upload-gallery-image"
                key={file.name}
              >
                <span>{file.name}</span>
                <TrashSvg
                  className="new-project-image-upload-gallery-image__trash"
                  onClick={() => handleRemoveImage(file)}
                />
              </div>
            );
          })}
        </div>
      </div>
      <div className="new-project-image-upload-footer">
        <Button
          label={TranslationCommon("Return")}
          variant={"secondary"}
          leadingIcon={<ArrowLeftSvg />}
          onClick={handleReturn}
        />
        <Button
          label={TranslationCommon("Continue")}
          trailingIcon={<ArrowRightSvg />}
          onClick={handleContinue}
        />
      </div>
    </div>
  );
};

UploadWorks.propTypes = {};

export default UploadWorks;
